import(/* webpackMode: "eager", webpackExports: ["BlogList"] */ "/vercel/path0/src/components/Blog/BlogList.tsx");
